import Axios from 'axios';

export default {
  create(agreementRule) {
    return Axios.post('/admin/debt-agreement-rules', agreementRule);
  },

  loadEnumsDebtAgreementRules() {
    return Axios.get('/admin/debt-agreement-rules/enums');
  },

  disableAgreementRule(id) {
    return Axios.put(`/admin/debt-agreement-rules/${id}/disable`);
  },

  getDebtAgreementRules(institutionId) {
    return Axios.get('/admin/debt-agreement-rules', { params: { institution_id: institutionId } })
      .then(({ data }) => data);
  },
};
